import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  const loaderStyle = {
    width: "90px",
    height: "20px",
    WebkitMask: "linear-gradient(90deg, #4b38b3 70%, transparent 0) 0/20%",
    background:
      "linear-gradient(#4b38b3 0 0) 0/0% no-repeat #ddd",
    animation: "l4 2s infinite steps(6)",
  };

  const keyframes = `
    @keyframes l4 {
      100% { background-size: 120% }
    }
  `;

  return (
    <React.Fragment>
      {/* Injecting keyframes dynamically */}
      <style>{keyframes}</style>

      <div className="d-flex justify-content-center mx-2 mt-2">
        <div style={loaderStyle}></div> {/* Inline Loader */}
      </div>

      {toast.error(props.error, {
        position: "top-right",
        hideProgressBar: false,
        progress: undefined,
        toastId: "",
      })}
    </React.Fragment>
  );
};

export default Loader;
